export default "__VITE_ASSET__eed6ff9c__"